<article [class]="'entry-card' + (entryClass ? ' ' + entryClass : '')">
  <div class="thumb" [style.background-image]="entry.fields.thumbImage ? 'url(' + entry.fields.thumbImage.fields.file.url + ')' : 'url(' + placeholderImg + ')'" (click)="onOpen()"></div>
  <div class="info">
    <h3><a (click)="onOpen()">{{ entry.fields.title }}</a></h3>
    <p class="entry-content" [innerHTML]="contentService.getExcerpt(entry.fields.description, excerptLimit, true)"></p>
		<a class="read-more textlink" (click)="onOpen()">Read more &gt;</a>
    <div class="meta">
      <span class="category">{{ entry.fields?.categories?.slice(0, 2).join(', ') }}</span>
      <!--span class="tags">{{ entry.metadata?.tags?.join(', ') }}</span-->
    </div>
  </div>
</article>
